import { graphql, useStaticQuery } from "gatsby"

interface EmailsBalcklistDato {
  datoCms: {
    emailBlacklist: {
      domains: string
    }
  }
}
export const useEmailsBlacklist = () => {
  const { datoCms } = useStaticQuery<EmailsBalcklistDato>(graphql`
    query DatoCmsEmailBlacklistQuery {
      datoCms {
        emailBlacklist {
          domains
        }
      }
    }
  `)
  const { domains: blacklistedDomains } = datoCms.emailBlacklist
  return blacklistedDomains.split("\n")
}
